import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/helpers/axios";
import type { ApiResponse } from "@/helpers/axios";
import type {
  FormApplication,
  FormsApplicationsMeta,
} from "@/app/inbox/forms/_types/formsApplications.types";

const OVERVIEW_FORMS_LIMIT = 4;

export const useOverviewUnreadFormsQuery = () => {
  return useQuery({
    queryKey: ["overview", "forms-unread", OVERVIEW_FORMS_LIMIT],
    queryFn: async () => {
      const response = await axiosInstance.get<
        ApiResponse<FormApplication[], FormsApplicationsMeta>
      >("/v2/inbox/forms/applications", {
        params: {
          type: "all",
          period: "all",
          status: "unread",
          page: 1,
          limit: OVERVIEW_FORMS_LIMIT,
        },
      });

      return {
        items: response.data.data ?? [],
        meta: response.data.meta,
      };
    },
  });
};
